export default {
    greens: {
        pastelGreen: '#5CDB59',
        magicMint: '#84EEAF',
        lochinvar: '#379683',
        loafer: '#EDF5E1'
    },
    blues: {
        catalinaBlue: '#05396B'
    },
    greys: {
        porcelain: '#F1F3F4'
    }
}